import { OrganizationStatus } from '../Enums/organization-status.enum';
import { PaymentHealth } from '../Enums/payment-health.enum';
import { StatusTone } from '../Modules/Shared/Types/status-tone.type';

// Paging — core/api BackofficeHelper

export const FIRST_PAGE = 0;

export const DEFAULT_PAGE_SIZE = 25;

export const MAX_PAGE_SIZE = 100;

export const PAGE_SIZE_OPTIONS: readonly number[] = [10, 25, 50, 100];

export const COUNT_PROBE_PAGE_SIZE = 1;

export const EXPORT_CAP = 5000;

// Organization status

export const ORGANIZATION_STATUS_OPTIONS: readonly OrganizationStatus[] = [
  OrganizationStatus.ACTIVE,
  OrganizationStatus.SUSPENDED,
  OrganizationStatus.CANCELLED,
];

export const ORGANIZATION_STATUS_LABEL: Readonly<Record<string, string>> = {
  [OrganizationStatus.ACTIVE]: 'backoffice.enums.organization_status.active',
  [OrganizationStatus.SUSPENDED]: 'backoffice.enums.organization_status.suspended',
  [OrganizationStatus.CANCELLED]: 'backoffice.enums.organization_status.cancelled',
};

export const ORGANIZATION_STATUS_TONE: Readonly<Record<string, StatusTone>> = {
  [OrganizationStatus.ACTIVE]: 'positive',
  [OrganizationStatus.SUSPENDED]: 'warning',
  [OrganizationStatus.CANCELLED]: 'danger',
};

// Payment health

export const PAYMENT_HEALTH_LABEL: Readonly<Record<string, string>> = {
  [PaymentHealth.CURRENT]: 'backoffice.enums.payment_health.current',
  [PaymentHealth.PAST_DUE]: 'backoffice.enums.payment_health.past_due',
  [PaymentHealth.CANCELED]: 'backoffice.enums.payment_health.canceled',
  [PaymentHealth.UNPAID]: 'backoffice.enums.payment_health.unpaid',
};

export const PAYMENT_HEALTH_TONE: Readonly<Record<string, StatusTone>> = {
  [PaymentHealth.CURRENT]: 'positive',
  [PaymentHealth.PAST_DUE]: 'warning',
  [PaymentHealth.CANCELED]: 'neutral',
  [PaymentHealth.UNPAID]: 'danger',
};

// Fallbacks

export const VALUE_UNRESOLVED = '—';

export const CURRENCY_UNRESOLVED_HINT = 'backoffice.common.currency_unresolved';

export const DATE_FORMAT = 'dd MMM yyyy';

export const DATE_TIME_FORMAT = 'dd MMM yyyy, HH:mm';

// Dashboard

export const REVENUE_SCAN_PAGE_SIZE = MAX_PAGE_SIZE;

export const PLAN_SCAN_PAGE_SIZE = MAX_PAGE_SIZE;

export const TREND_UNAVAILABLE_REASON = 'backoffice.dashboard.trends.unavailable';

export const REVENUE_PARTIAL_HINT = 'backoffice.dashboard.revenue.partial_hint';

export const RESTRICTED_METRIC_HINT = 'backoffice.dashboard.metric.restricted_hint';
